import "./ErrorPage.scss";

import { app } from "@microsoft/teams-js";
import { helpDeepLink } from "@teams/cards";
import React from "react";

import ErrorImage from "../../assets/error-image.png";
import { getHelpAppId } from "../../utils/teamsHelpers";

export const ErrorPage: React.FC = () => {
  const handleHelpButtonClick = () => {
    app.openLink(
      helpDeepLink({
        appId: getHelpAppId(),
      })
    );
  };
  return (
    <div className="error-page__container">
      <div>
        <h1 className="error-page__header">Oops! Looks like we took a wrong turn somewhere.</h1>
      </div>
      <div>
        <h2 className="error-page__subheader">
          We hit an error, try navigating to{" "}
          <button
            data-tname="error-page-polly-help-link"
            onClick={handleHelpButtonClick}
            className="error-page__link"
          >
            Polly Help
          </button>{" "}
          to find what you're looking for.
        </h2>
      </div>
      <div className="error-page__image-container">
        <img className="error-page__image" src={ErrorImage} alt="Error" />
      </div>
    </div>
  );
};
